var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsubscribe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.89474 7.10526L1.57895 3.15789V11.0526H7.89474C7.89474 11.3289 7.91447 11.5954 7.95395 11.852C7.99342 12.1086 8.05263 12.3684 8.13158 12.6316H1.57895C1.14474 12.6316 0.773026 12.477 0.463816 12.1678C0.154605 11.8586 0 11.4868 0 11.0526V1.57895C0 1.14474 0.154605 0.773026 0.463816 0.463816C0.773026 0.154605 1.14474 0 1.57895 0H14.2105C14.6447 0 15.0164 0.154605 15.3257 0.463816C15.6349 0.773026 15.7895 1.14474 15.7895 1.57895V6.07895C15.5526 5.96053 15.2993 5.86184 15.0296 5.7829C14.7599 5.70395 14.4868 5.64474 14.2105 5.60526V3.15789L7.89474 7.10526ZM7.89474 5.52632L14.2105 1.57895H1.57895L7.89474 5.52632ZM13.4211 15C12.3289 15 11.398 14.6151 10.6283 13.8454C9.85855 13.0757 9.47368 12.1447 9.47368 11.0526C9.47368 9.96053 9.85855 9.02961 10.6283 8.25987C11.398 7.49013 12.3289 7.10526 13.4211 7.10526C14.5132 7.10526 15.4441 7.49013 16.2138 8.25987C16.9836 9.02961 17.3684 9.96053 17.3684 11.0526C17.3684 12.1447 16.9836 13.0757 16.2138 13.8454C15.4441 14.6151 14.5132 15 13.4211 15ZM11.0526 11.4474H15.7895V10.6579H11.0526V11.4474Z",
    fill: "#004F6E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsubscribe);
export default __webpack_public_path__ + "static/media/Unsubscribe.c83315b54062b8143af0c24987d0d128.svg";
export { ForwardRef as ReactComponent };